<template>
  <div style="padding: 50px;">
    <input type="range" v-model="emailWidth"  min="300" max="900"/> Width: {{ emailWidth }}
    <br/>
    Inventory Items
    <div>
      <draggable class="list-group" ghost-class="ghost" :move="checkMove" :list="inv" @start="drag=true" @end="drag=false" v-bind="dragOptions">
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <div v-for="(item, index) in inv" :key="index" style="margin-bottom: 15px; width: fit-content; min-width: 400px;" class="list-group-item">
            <div v-if="item.type == 'single'" style="display: flex;" :class="{inactiveItem: (!item.active && updatingList == null) || InactiveFromSelection(item) }">
              <div class="cursor-pointer" style="min-width: 80px;" @click="ClickItem(item)">
                <img :src="`${item.imgSrc}${item.aspectRatio == null ? '' : '&aspect_ratio=' + item.aspectRatio}`" style="width: 80px;"/>
              </div>
              <select v-model="item.aspectRatio" style="height: 50px; margin-left: 10px;">
                  <option value="none" default>none</option>
                  <option value="16:9">16:9</option>
                  <option value="14:9">14:9</option>
                  <option value="4:3">4:3</option>
                  <option value="1:1">1:1</option>
                  <option value="3:4">3:4</option>
                  <option value="1:2">1:2</option>
                </select>
              <div style="margin-left: 10px; width: 100%;">
                <input style="margin-left: 5px; width: 100%;" v-model="item.name" />
                <br/>
                <textarea style="margin-left: 5px; width: 100%; font-size: 10px;" v-model="item.description" v-if="item.description.length > 40"/>
                <input style="margin-left: 5px; width: 100%;" v-model="item.description" v-if="item.description.length <= 40"/>
                <input style="margin-left: 5px; width: 100%;" v-model="item.link" /> <span style="margin-left: -40px; color: white; font-size: 12px;">Link</span>
              </div>
            </div>
            <div v-if="item.type == 'listing'" style="display: flex;" :class="{inactiveItem: !item.active}">
              <div style="min-width: 80px; overflow: hidden; height: 50px;" class="cursor-pointer" @click="item.active = !item.active">
                <img src="https://saturiwa.b-cdn.net/multipleFiles.png" style="width: 60px; padding: 10px;"/>
              </div>
              <div style="margin-left: 10px; width: 100%;">
                <input style="margin-left: 5px; width: 100%;" v-model="item.name" />
                <br/>
                <select v-model="item.listType">
                  <option value="list">list</option>
                  <option value="columns">columns</option>
                </select>
                <button @click="updatingList = (updatingList == null ? item : null)">
                  {{ updatingList == null ? 'Update List' : 'Stop'}}
                </button>
                <br/>
                <draggable class="list-group" ghost-class="ghost" :move="checkMove" :list="item.items" @start="drag=true" @end="drag=false">
                  <div v-for="(listingItem, index2) in item.items" :key="index2" class="list-group-item" style="font-size: 12px;">
                    {{ inv.find(x => x.id == listingItem).name }}
                  </div>
                </draggable>
                <br />
              </div>
            </div>
            <div v-if="item.type == 'listing'" style="display: flex; margin-botton: 10px;">
              
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
    <br/>
    <button @click="AddItem('single')">ADD NEW ITEM</button>
    <button @click="AddItem('listing')">ADD NEW LIST</button>

    <br/><br/>
    <div style="background: #00000011; height: 100vh; position: fixed; right: 20px; top: 0px;" id="emailParent" :style="{width: `${emailWidth}px`}">
      <!-- <div v-html="mjmlHTML">
        {{mjmlHTML}}
      </div> -->
      <button @click="GenerateCode()" style="position: absolute; top: 20px; left: -130px;"> Generate Code </button>
      <iframe :srcdoc="mjmlHTML" style="width: 100%; height: 100%;"></iframe>
    </div>
    <div style="padding: 20px; width: 400px; font-size: 1px;line-height: 1px;">
      {{ mjmlHTML }} {{style}}
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  data() {
    return {
      emailWidth: 700,
      code: '',
      orderedArr: [],
      drag: false,
      updatingList: null,
      style: `<style>
    @media screen and (max-width:600px) {
         .block { display: block !important; width: 100% !important; }
    }
 </style>`,
    }
  },
  computed: {
    mjmlHTML() {
      return this.$store.getters.GetMJMLHTML
    },
    inv() {
      return this.$store.getters.GetEmailInventory
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    InactiveFromSelection(item) {
      if (this.updatingList == null) {
        return false
      }
      if (this.updatingList.items.indexOf(item.id) == -1) {
        return true
      }
      return false
    },
    ClickItem(item) {
      if (this.updatingList == null) {
        item.active = !item.active
      } else {
        const index = this.updatingList.items.indexOf(item.id)
        if (index == -1) {
          this.updatingList.items.push(item.id) 
        } else {
          this.updatingList.items.splice(index, 1)
        }
      }
    },
    AddItem(itemType) {
      this.$store.dispatch('ActionAddEmailItem', itemType)
    },
    GenerateCode() {
      // const node = document.getElementById("emailParent")
      // const clone = node.cloneNode(true)
      // this.code = clone.innerHTML
      this.$store.dispatch('ActionGetMJMLHTML')
    },
    GetListingItems(listing) {
      if (listing.listType == 'list') {
        const ret = []
        for (let i = 0; i < listing.items.length; i += 1) {
          ret.push(this.inv.find (x => x.id == listing.items[i]))
          // ret.push(this.inv[listing.items[i]])
        }
        return ret
      } else if (listing.listType == 'columns') {
        const ret = { first: [], second: []}
        const half = Math.floor(listing.items.length / 2)
        for (let i = 0; i < half; i += 1) {
          ret.first.push(this.inv.find (x => x.id == listing.items[i]))
        }
        for (let i = half; i < listing.items.length; i += 1) {
          ret.second.push(this.inv.find (x => x.id == listing.items[i]))
        }
        return ret
      }
    },
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
  },
  mounted() {
    this.GenerateCode()
  },
}
</script>

<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group-item:nth-child(odd) {
  background: #f8f8f8;
  border-radius: 2px;
  padding: 5px;
}

.list-group-item:nth-child(even) {
  background: white;
  border-radius: 2px;
  padding: 5px;
}

.inactiveItem {
  opacity: .5;
}

input {
  border: none;
  background: #e2e2e2;
  padding: 4px;
}

</style>


<style>
    @media screen and (max-width:600px) {
         .block { display: block !important; width: 100% !important; }
    }
 </style>